import { useBrand } from "../brand/BrandContext";
import { VARIANT_ORDER, VARIANTS } from "../brand/tokens";

/**
 * Floating variant toggle. Pinned bottom-right on every page (except
 * print mode). Tapping a chip swaps fonts + palette across the entire
 * book instantly. The trailing download icon pulls the PDF export for
 * whichever variant is currently active.
 */
export function VariantToggle() {
  const { variantId, variant, setVariant } = useBrand();

  return (
    <div className="pointer-events-none fixed right-5 bottom-5 z-40 print:hidden">
      <div
        className="pointer-events-auto flex items-center gap-1 rounded-full p-1.5"
        style={{
          background: "var(--ink)",
          boxShadow: "0 12px 36px rgba(0,0,0,0.22)",
        }}
      >
        {VARIANT_ORDER.map((id) => {
          const v = VARIANTS[id];
          const active = id === variantId;
          return (
            <button
              key={id}
              type="button"
              onClick={() => setVariant(id)}
              className={`group flex items-center gap-2.5 rounded-full px-3.5 py-2 font-body text-[12px] transition-all ${
                active ? "" : "opacity-65 hover:opacity-100"
              }`}
              style={{
                background: active ? v.palette.amber : "transparent",
                color: active ? v.palette.ink : v.palette.paper,
              }}
              aria-pressed={active}
              title={v.oneLiner}
            >
              <span
                className="h-2 w-2 rounded-full"
                style={{
                  background: active ? v.palette.ink : v.palette.amber,
                }}
              />
              <span
                className="font-medium tracking-[0.04em]"
                style={{
                  color: active ? v.palette.ink : v.palette.paper,
                }}
              >
                {v.name}
              </span>
            </button>
          );
        })}
        <a
          href={`/pdf/brandbook-${variantId}.pdf`}
          download={`brandbook-${variantId}.pdf`}
          className="ml-1 flex h-9 w-9 items-center justify-center rounded-full transition-opacity hover:opacity-100"
          style={{
            color: variant.palette.paper,
            opacity: 0.75,
          }}
          title={`Download the ${variant.name} brandbook as PDF`}
          aria-label={`Download the ${variant.name} brandbook as PDF`}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </a>
      </div>
    </div>
  );
}
